// exp_PORTFOLIO-61587_file
export enum VacancyOfTheDayPresetId {
    Small = 'SMALL',
    Medium = 'MEDIUM',
    Large = 'LARGE',
    Custom = 'CUSTOM',
}

export interface VacancyOfTheDayPreset {
    budget: number;
    clicks: number;
}

export interface VacancyOfTheDayPresets {
    SMALL: VacancyOfTheDayPreset;
    MEDIUM: VacancyOfTheDayPreset;
    LARGE: VacancyOfTheDayPreset;
}

export const RUBLES_PER_CLICK = 50;
export const PERIOD_DAYS = 7;
export const CTR_PERCENT = 0.5;
export const CLICKS_INPUT_STEP = 50;

export const BASE_VACANCY_OF_THE_DAY_PRESETS: VacancyOfTheDayPresets = {
    SMALL: { budget: 1500, clicks: 30 },
    MEDIUM: { budget: 3000, clicks: 60 },
    LARGE: { budget: 5000, clicks: 100 },
};

export const clicksFromBudget = (budget: number): number => Math.floor(budget / RUBLES_PER_CLICK);

export const budgetFromClicks = (clicks: number): number => clicks * RUBLES_PER_CLICK;

export interface VacancyOfTheDayForecast {
    periodDays: number;
    impressions: number;
    ctrPercent: number;
}

export const getVacancyOfTheDayForecast = (clicks: number): VacancyOfTheDayForecast => ({
    periodDays: PERIOD_DAYS,
    impressions: Math.round(clicks / (CTR_PERCENT / 100)),
    ctrPercent: CTR_PERCENT,
});

export interface VacancyOfTheDayErrors {
    areas: boolean;
    roles: boolean;
    clicks: boolean;
    budget: boolean;
}

export const EMPTY_VACANCY_OF_THE_DAY_ERRORS: VacancyOfTheDayErrors = {
    areas: false,
    roles: false,
    clicks: false,
    budget: false,
};

interface VacancyOfTheDayValidationInput {
    areas: number[];
    roles: number[];
    preset: VacancyOfTheDayPresetId;
    clicks: number;
    budget: number;
    presets: VacancyOfTheDayPresets;
}

export const getVacancyOfTheDayErrors = ({
    areas,
    roles,
    preset,
    clicks,
    budget,
    presets,
}: VacancyOfTheDayValidationInput): VacancyOfTheDayErrors => {
    const isCustom = preset === VacancyOfTheDayPresetId.Custom;

    return {
        areas: areas.length === 0,
        roles: roles.length === 0,
        clicks: isCustom && clicks < presets.SMALL.clicks,
        budget: isCustom && budget < presets.SMALL.budget,
    };
};

export const hasVacancyOfTheDayErrors = (errors: VacancyOfTheDayErrors): boolean => Object.values(errors).some(Boolean);
